import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const DARK_TOOLTIP_COLOR = '#333';
const LIGHT_TOOLTIP_COLOR = '#f5f5f9';
const ABOVE_EVERYTHING_Z_INDEX = 2147483647;

const INHERITED_WEIGHT_TEXT = { fontWeight: 'inherit', lineHeight: '1.4em' };

const variantSx = {
  light: {
    ...INHERITED_WEIGHT_TEXT,
    backgroundColor: LIGHT_TOOLTIP_COLOR,
    color: 'rgba(0, 0, 0, 0.9)',
    maxWidth: 400,
    fontSize: '1rem',
    border: '1px solid #dadde9',
    '& b': {
      fontWeight: 400,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: LIGHT_TOOLTIP_COLOR,
      '&::before': {
        border: '1px solid #dadde9',
      },
    },
  },
  dark: {
    ...INHERITED_WEIGHT_TEXT,
    backgroundColor: DARK_TOOLTIP_COLOR,
    color: '#fff',
    maxWidth: 800,
    borderRadius: '4px',
    fontSize: '0.95rem',
    padding: '0.4rem 0.8rem',
    textAlign: 'left',
    '& a': {
      color: '#cfef4a',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: DARK_TOOLTIP_COLOR,
    },
  },
};

const POPPER_SX = { zIndex: ABOVE_EVERYTHING_Z_INDEX };
const ARROW_PROPS = { 'data-testid': 'tooltip-arrow' };

const CustomTooltip = ({
  arrow = false,
  children,
  className,
  content,
  placement = 'bottom',
  variant = 'light',
}) => (
  <Tooltip
    arrow={arrow}
    describeChild
    placement={placement}
    slotProps={{
      arrow: ARROW_PROPS,
      popper: { sx: POPPER_SX },
      tooltip: { sx: variantSx[variant] },
    }}
    title={content}
  >
    <div className={className} style={{ display: 'inline' }}>
      {children}
    </div>
  </Tooltip>
);

export default CustomTooltip;
